import './comp_steering_certificate.css'

const Comp_Steering_Certificate=(props)=>{
    return(

        <div class="steering-certificate">
        <div class="header-container">
            <div class="header-box">Section 9.6- Steerinsr Certificate</div>
            <div class="header-box">To be issued by the Master once all<br/>
            Steering Training is completed and<br/>
            the cadet is considered proficient. 
            n</div>
        </div>
        
        <div class="logo-container">
            <img src="../logo.png" alt="GlobalMET Logo" class="main-logo"/>
            <img src="../dg_shipping_logo.png" alt="General Logo" class="logo"/>
            {/* <img src="../umulogo.png" alt="Maritime Logo" class="logo"/> */}
        </div>
        
        <div class="certificate-title">Steering Certificate</div>
        
        <div class="cadet-info">
            Name of Cadet: _______________________________<br/>
            Date of birth: _______________________________<br/>
            Passport number: _______________________________
        </div>
        
        <div class="headingg">This is to certify that the above named Cadet has served on board the ship</div>
        
        <div class="ship-period-line">
            <span></span> from <span></span> to <span></span>.
        </div>
        
        <div class="description">
        During this period of structured shipboard training, the Cadet took turns at steering the ship (apart from the periods of instruction) as given below: 
        </div>
        
        <div  class="headingg">The number of bridge watches kept is as follows:</div>
        
        <div class="table-container">
            <table class="table">
                <tr>
                    <th>Steering</th>
                    <th>Total Hours </th>
                </tr>
                <tr>
                    <td>By compass during day </td>
                    <td></td>
                    
                </tr>
                <tr>
                    <td>By compass during night</td>
                    <td></td>
                   
                </tr>
                <tr>
                    <td>By sight (without compass)</td>
                    <td></td> 
                </tr>
                <tr>
                    <td>While entering and leaving port</td>
                    <td></td>
                </tr>
            </table>
            <div>
                <div class="signature-container">Master’s signature & ship’s stamp</div>
                <div class="signature-details">
                    <p>Master's Name: __________________________</p>
                    <p>Date: _____________</p>
                </div>
            </div>
        </div>
        <div class="bottom-note">
        This is to certify that the Cadet has been found proficient in steering the ship by hand. 
        </div>
    
      </div>
    );
}

export default Comp_Steering_Certificate